(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["admin3-merchant-app"] = factory();
	else
		root["admin3-merchant-app"] = factory();
})(window, function() {
return 